import * as React from 'react';
import StyledSearchInput from '@elevio/styles/lib/components/Search';
import useSearch from '../hooks/useSearch';
import { LoopResults, IsEmpty, IsNotEmpty } from './searchResults';

export { LoopResults, IsEmpty, IsNotEmpty };

// This is the typescript def for the input jsx
type InputProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
>;

export const Input: React.FC<InputProps> = ({ ...rest }) => {
  const { value, onChange, onKeyUp, onOpenDropdown } = useSearch();

  return (
    <input
      {...rest}
      type={rest.type || 'search'}
      value={value}
      onKeyUp={onKeyUp}
      onChange={onChange}
      onFocus={onOpenDropdown}
      data-testid="search-input"
    />
  );
};

type SearchProps = JSX.IntrinsicElements['input'];
export const Search: React.FC<SearchProps> = (props) => {
  const { value, onChange, onKeyUp } = useSearch();
  return (
    <StyledSearchInput
      {...props}
      value={value}
      onKeyUp={onKeyUp}
      onChange={onChange}
    />
  );
};
